import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import { CAMPAIGN_TYPES } from '../../../../common/enums/enums';
import { getEnumColor } from '../../../../../utils/enumUtils';

const NameCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const badgeColor = getEnumColor(CAMPAIGN_TYPES, rowData.type);
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Group gap={'xs'}>
                    <Text size={'sm'}>{rowData.name} </Text>
                    <Badge
                        color={badgeColor}
                        size={'xs'}>
                        {rowData.type}
                    </Badge>
                </Group>
                <Text size={'sm'}>{rowData.dataset?.label}</Text>
            </Stack>
        </Box>
    );
};

const NameColumn = () => ({
    accessorKey: 'name',
    header: 'Name',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NameCell cell={cell} />,
});
export default NameColumn;
